import type {
  CreateRootFiInviteLinkBody,
  CreateRootFiInviteLinkResponse,
} from '@commenda/types/src/root-fi/types';
import {
  fetcher,
  messageFromApiErrorBody,
  readJsonResponseBody,
} from '@commenda/utils';

export async function createRootFiInviteLink(
  body: CreateRootFiInviteLinkBody
): Promise<{
  success: boolean;
  data?: CreateRootFiInviteLinkResponse;
  error?: unknown;
}> {
  try {
    const response = await fetcher('rootfi/invite-link', {
      method: 'POST',
      body: {
        corporationId: body.corporationId,
        useCases: body.useCases,
        integration: body.integration,
        companyName: body.companyName.trim(),
        serviceRequestTaskId: body.serviceRequestTaskId,
        syncFrom: body.syncFrom,
        syncConfig: body.syncConfig?.map((row) => ({
          interval: row.interval ?? 1,
          frequency: row.frequency,
          data_model: row.data_model,
          category: row.category,
          scope_access: row.scope_access,
          enabled: row.enabled,
          sync_from: row.sync_from ?? undefined,
        })),
      },
    });

    if (!response.ok) {
      const errorBody = await readJsonResponseBody(response);
      return {
        success: false,
        error: messageFromApiErrorBody(
          errorBody,
          'Failed to create invite link'
        ),
      };
    }

    const data = (await response.json()) as CreateRootFiInviteLinkResponse;
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create invite link';
    return { success: false, error: errorMessage };
  }
}
